import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { Dialog, TextField } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDebounce } from 'react-use';
import Loader from 'components/common/Loader';
import { VideoPreview } from 'components/common/VideoPreview';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { SearchItemList } from 'components/content/SearchItemList';
import { useFindVideos, useSiteConfig } from 'libs/common/hooks';
import { Video } from 'theme/icons';
import { ButtonContainer, CloseButton, Description, FieldContainer, Title, VideoPreviewContainer } from './VideoDialog.style';

// eslint-disable-next-line complexity
var VideoDialog = function VideoDialog(_ref) {
  var _videoData$title, _videoData$videoIfram;

  var open = _ref.open,
      initialVideoData = _ref.initialVideoData,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id;

  var _useState = useState(''),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = useState(initialVideoData),
      videoData = _useState2[0],
      setVideoData = _useState2[1];

  var intl = useIntl();

  var _useFindVideos = useFindVideos(site),
      error = _useFindVideos.error,
      loading = _useFindVideos.loading,
      videos = _useFindVideos.videos,
      doFindVideos = _useFindVideos.doFindVideos;

  var isVideoSelected = error === undefined && !isEmpty(videoData === null || videoData === void 0 ? void 0 : videoData.videoId);
  var isAnyVideoFound = error === undefined && videos !== undefined;
  var hasError = error !== undefined || videos !== undefined && isEmpty(videos);

  var _useState3 = useState(false),
      hasResetVideo = _useState3[0],
      setHasResetVideo = _useState3[1];

  var displayLoading = useMemo(function () {
    if (loading) {
      return loading;
    }

    return !!searchText && !isAnyVideoFound && error === undefined;
  }, [loading, searchText, isAnyVideoFound, error]);
  var displaySearchItemList = useMemo(function () {
    return isAnyVideoFound && !isVideoSelected && !hasError;
  }, [hasError, isAnyVideoFound, isVideoSelected]);
  useEffect(function () {
    if (initialVideoData !== undefined) {
      setVideoData(initialVideoData);
    }
  }, [initialVideoData]);
  useDebounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = searchText;

            if (!_context.t0) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return doFindVideos(searchText);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 500, [searchText]);

  var onItemClicked = function onItemClicked(item) {
    setVideoData({
      title: item.title,
      imgUrl: item.imageUrl,
      videoId: item.id,
      videoIframeUrl: item.iframeUrl
    });
  };

  var handleSearchTextChange = function handleSearchTextChange(event) {
    return setSearchText(event.target.value);
  };

  var handleConfirm = function handleConfirm() {
    setHasResetVideo(false);
    onConfirm(videoData);
  };

  var handleClose = function handleClose() {
    setHasResetVideo(false);
    setVideoData(initialVideoData);
    onClose();
  };

  var resetSelectedVideo = function resetSelectedVideo() {
    setHasResetVideo(true);
    setVideoData({
      title: '',
      imgUrl: '',
      videoId: '',
      videoIframeUrl: ''
    });
  };

  return __jsx(Dialog, {
    open: open,
    onClose: handleClose
  }, __jsx(CloseButton, {
    onClick: handleClose,
    "data-testid": "close-button"
  }), __jsx(FormattedMessage, {
    id: "video-modal.title",
    tagName: Title
  }), __jsx(FormattedMessage, {
    id: "video-modal.description",
    tagName: Description
  }), !isVideoSelected && __jsx(FieldContainer, null, __jsx(TextField, {
    id: "video-searchtext",
    variant: "outlined",
    label: __jsx(FormattedMessage, {
      id: "video-modal.videoSearchTextField"
    }),
    type: "text",
    fullWidth: true,
    value: searchText,
    onChange: handleSearchTextChange,
    error: hasError,
    helperText: hasError ? intl.formatMessage({
      id: 'video-modal.videoSearchTextFieldError'
    }) : ''
  })), displayLoading ? __jsx(Loader, null) : displaySearchItemList && __jsx(SearchItemList, {
    searchItems: videos !== null && videos !== void 0 ? videos : [],
    fieldsMapping: {
      id: 'id',
      label: 'title',
      subLabel: '',
      previewImage: 'imageUrl'
    },
    HoverIcon: Video,
    onClick: onItemClicked
  }), isVideoSelected && __jsx(VideoPreviewContainer, null, __jsx(VideoPreview, {
    title: (_videoData$title = videoData === null || videoData === void 0 ? void 0 : videoData.title) !== null && _videoData$title !== void 0 ? _videoData$title : '',
    iframeUrl: (_videoData$videoIfram = videoData === null || videoData === void 0 ? void 0 : videoData.videoIframeUrl) !== null && _videoData$videoIfram !== void 0 ? _videoData$videoIfram : '',
    editFormattedMessage: "video-preview.replace",
    onReplaceButtonClick: resetSelectedVideo
  })), __jsx(ButtonContainer, null, __jsx(GradientButton, {
    disabled: isEmpty(videoData === null || videoData === void 0 ? void 0 : videoData.videoId) && !hasResetVideo,
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "video-modal.confirm"
  }))));
};

export default VideoDialog;